import React from "react";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import { withRouter } from "react-router";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandshake } from "@fortawesome/free-solid-svg-icons";
import { faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { primaryShade1, grey, white } from "../styles/color";

class SimpleBottomNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bottamNavValue: 0
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData(whichProps) {
    if (whichProps.selectedValue === 2) {
      this.setState({ bottamNavValue: whichProps.selectedValue });
    }
    if (whichProps.selectedValue === 1) {
      this.setState({ bottamNavValue: whichProps.selectedValue });
    }
    if (whichProps.selectedValue === 0) {
      this.setState({ bottamNavValue: whichProps.selectedValue });
    }
  }

  render() {
    const { bottamNavValue } = this.state;
    return (
      <BottomNavigation
        value={bottamNavValue}
        showLabels
        style={{
          boxShadow: "0px -1px 5px rgba(50, 50, 50, 0.25)",
          position: "fixed",
          bottom: "0px",
          width: "100%",
          backgroundColor: white
        }}
      >
        <BottomNavigationAction
          style={{
            color: bottamNavValue === 0 ? white : grey,
            backgroundColor: bottamNavValue === 0 ? primaryShade1 : white
          }}
          label={<span>Deals</span>}
          icon={<FontAwesomeIcon icon={faHandshake} size={"2x"} />}
          onClick={e => {
            e.preventDefault();
            this.props.history.push("/deals");
          }}
        />
        <BottomNavigationAction
          style={{
            color: bottamNavValue === 1 ? white : grey,
            backgroundColor: bottamNavValue === 1 ? primaryShade1 : white
          }}
          label={<span>Invoice</span>}
          icon={<FontAwesomeIcon icon={faMoneyBillAlt} size={"2x"} />}
          onClick={e => {
            e.preventDefault();
            this.props.history.push("/invoice");
          }}
        />
        <BottomNavigationAction
          style={{
            color: bottamNavValue === 2 ? white : grey,
            backgroundColor: bottamNavValue === 2 ? primaryShade1 : white
          }}
          label={<span>Settings</span>}
          icon={<FontAwesomeIcon icon={faCog} size={"2x"} />}
          onClick={e => {
            e.preventDefault();
            this.props.history.push("/settings");
          }}
        />
      </BottomNavigation>
    );
  }
}

export default withRouter(SimpleBottomNavigation);
